import { render, staticRenderFns } from "./permissionDenied.vue?vue&type=template&id=786319f5&"
import script from "./permissionDenied.vue?vue&type=script&lang=js&"
export * from "./permissionDenied.vue?vue&type=script&lang=js&"
import style0 from "./permissionDenied.vue?vue&type=style&index=0&id=786319f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports